// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-0a985da2]{border-collapse:collapse}table[data-v-0a985da2],td[data-v-0a985da2],th[data-v-0a985da2]{border:.5px solid #000}thead[data-v-0a985da2]{display:table-row-group}tr td[data-v-0a985da2]{page-break-inside:avoid}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
